import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
const FADE_PX = 24;
const buildMaskImage = (atTop: boolean, atBottom: boolean) => `linear-gradient(to bottom, ${atTop ? '#000' : 'transparent'} 0, #000 ${FADE_PX}px, #000 calc(100% - ${FADE_PX}px), ${atBottom ? '#000' : 'transparent'} 100%)`;

/**
 * Vertical twin of useHorizontalScrollFade: an edge fade marking the side of a
 * scrollable region that still hides items. Pass the item count so the edges re-sync as
 * items stream in.
 */
export const useVerticalScrollFade = itemCount => {
  const $ = _c(9);
  const ref = useRef(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      atTop: true,
      atBottom: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, setEdges] = useState(t0);
  const {
    atTop,
    atBottom
  } = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const el = ref.current;
      if (!el) {
        return;
      }
      const syncEdges = () => {
        const max = el.scrollHeight - el.clientHeight;
        setEdges({
          atTop: el.scrollTop <= 1,
          atBottom: el.scrollTop >= max - 1
        });
      };
      syncEdges();
      el.addEventListener("scroll", syncEdges, {
        passive: true
      });
      const observer = new ResizeObserver(syncEdges);
      observer.observe(el);
      return () => {
        el.removeEventListener("scroll", syncEdges);
        observer.disconnect();
      };
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== itemCount) {
    t3 = [itemCount];
    $[2] = itemCount;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== atBottom || $[5] !== atTop) {
    t4 = buildMaskImage(atTop, atBottom);
    $[4] = atBottom;
    $[5] = atTop;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = {
      ref,
      maskImage: t4
    };
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};